import React from 'react';
import HeroSection from './HeroSection';
import FeaturedCollection from './FeaturedCollection';
import ImageWithText from './ImageWithText';
import FeaturesGrid from './FeaturesGrid';
import Testimonials from './Testimonials';
import Newsletter from './Newsletter';
import FAQ from './FAQ';
import ContactSection from './ContactSection';
import VideoBanner from './VideoBanner';
import LogoCloud from './LogoCloud';
import RichText from './RichText';
import CollectionList from './CollectionList';
import AnnouncementBar from './AnnouncementBar';
import Marquee from './Marquee';
import StoreHeader from './StoreHeader';
import StoreProductList from './StoreProductList';
import StoreFooter from './StoreFooter';

const SectionRenderer = ({ sections, sellerId, seller, isPreview }) => {
    if (!sections || sections.length === 0) return null;

    return (
        <div className="flex flex-col w-full">
            {sections.map((section) => {
                switch (section.type) {
                    case 'header':
                        return <StoreHeader key={section.id} settings={section.settings} storeName={seller?.shopInfo?.shopName} isPreview={isPreview} />;
                    case 'hero':
                        return <HeroSection key={section.id} settings={section.settings} />;
                    case 'featured-collection':
                        return <FeaturedCollection key={section.id} settings={section.settings} sellerId={sellerId} />;
                    case 'image-with-text':
                        return <ImageWithText key={section.id} settings={section.settings} />;
                    case 'features-grid':
                        return <FeaturesGrid key={section.id} settings={section.settings} />;
                    case 'testimonials':
                        return <Testimonials key={section.id} settings={section.settings} />;
                    case 'newsletter':
                        return <Newsletter key={section.id} settings={section.settings} />;
                    case 'store-product-list':
                        return <StoreProductList key={section.id} settings={section.settings} seller={seller} />;
                    case 'faq':
                        return <FAQ key={section.id} settings={section.settings} />;
                    case 'contact-section':
                        return <ContactSection key={section.id} settings={section.settings} />;
                    case 'video-banner':
                        return <VideoBanner key={section.id} settings={section.settings} />;
                    case 'logo-cloud':
                        return <LogoCloud key={section.id} settings={section.settings} />;
                    case 'rich-text':
                        return <RichText key={section.id} settings={section.settings} />;
                    case 'collection-list':
                        return <CollectionList key={section.id} settings={section.settings} />;
                    case 'announcement-bar':
                        return <AnnouncementBar key={section.id} settings={section.settings} />;
                    case 'marquee':
                        return <Marquee key={section.id} settings={section.settings} />;
                    case 'footer':
                        return <StoreFooter key={section.id} settings={section.settings} />;
                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default SectionRenderer;
